@if ({
  countriesOptions: (countriesOptions$ | async) ?? [],
  priceCountryData: (priceCountry$ | async) ?? priceCountryDataDefault,
  hasData: hasData
  }; as vm) {
  <div class="price-tiers-new p-4">
    <div class="page-heading mb-4 flex items-center justify-between">
      <div class="flex gap-4">
        <h3>View Country</h3>
      </div>
      <div>
        <a routerLink="./edit">
          <button class="btn-amber-soft">
            <svg-icon src="@assets/images/icons/pencil.svg" class="btn-icon"></svg-icon>
            <span>Edit</span>
          </button>
        </a>
      </div>
    </div>
    <!-- {{ vm.hasData }}
    {{ vm.priceCountryData | json }} -->
    @if (!vm.hasData) {
      <div class="text-center">Loading...</div>
    }
    @if (vm.hasData) {
      <div class="tier-form">
        <div class="card rounded-lg border border-neutral-100 px-6 py-9">
          @if (vm.priceCountryData && vm.countriesOptions.length > 0) {
            <app-form-price-country (init)="onInit($event)"
            [model]="vm.priceCountryData" [countries]="vm.countriesOptions"></app-form-price-country>
          }
        </div>
      </div>
    }
  </div>
}